import { type TicketRun } from '../../services/api/tickets';
import { cn } from '../../utils/cn';

export const TicketRunBanner = ({ run }: { run: TicketRun | null }) => (
  <div
    className={cn(
      'rounded-lg border px-3 py-2 text-sm flex flex-wrap items-center gap-x-4 gap-y-1',
      run?.status === 'failed'
        ? 'border-red-200 bg-red-50 text-red-800'
        : 'border-slate-200 bg-slate-50 text-slate-700',
    )}
  >
    {run ? (
      <>
        <span className="font-medium">Senaste körning {run.runDate}</span>
        <span>{run.sessionsScanned} skannade</span>
        <span>{run.sessionsAnalyzed} analyserade</span>
        <span>{run.sessionsFlagged} flaggade</span>
        <span>{run.ticketsCreated} tickets</span>
        {run.skippedDuplicates > 0 && <span>{run.skippedDuplicates} dubbletter hoppade</span>}
        {run.status === 'running' && <span className="text-indigo-700">pågår…</span>}
        {run.status === 'failed' && (
          <span className="font-medium">MISSLYCKADES: {run.error ?? 'okänt fel'}</span>
        )}
        {run.status === 'completed' && run.error && (
          <span className="text-amber-700">{run.error}</span>
        )}
      </>
    ) : (
      <span>
        Ingen nattkörning har loggats ännu — utkast dyker upp här när jobbet körts (eller när du
        skapar en ticket manuellt från en session).
      </span>
    )}
  </div>
);
